module.exports = __webpack_public_path__ + "static/media/siren1.7a8b4994.aac";